import Box, { boxClasses, BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { typographyClasses } from '@mui/material/Typography';
import { createContext, useContext } from 'react';

import { spacing } from '~theme/AppTheme';

import {
  JobsTableColumnKey,
  jobsTableColumns,
  OrdersPresentationMode,
} from './constants';
type ColumnProps = BoxProps & {
  columnKey: JobsTableColumnKey;
  isHeader?: boolean;
};

export const JobsTablePresentationContext =
  createContext<OrdersPresentationMode>('cards');

const ICON_WRAPPER_SELECTOR = `.${boxClasses.root}:has(> svg:only-child)`;

const singleLineCellSx = {
  alignItems: 'center',
  display: 'flex',
  gap: 0.5,
  [`& > .${boxClasses.root}`]: { alignSelf: 'center', gap: 1 },
  [`& .${boxClasses.root}`]: {
    alignItems: 'center',
    flexDirection: 'row',
    minWidth: 0,
  },
  [`& ${ICON_WRAPPER_SELECTOR}`]: { display: 'flex', flexShrink: 0 },
  [`& .${typographyClasses.root}`]: { width: 'auto' },
};

const StyledColumn = styled(Box, {
  shouldForwardProp: (propName) => propName !== 'isHeader',
})<Omit<ColumnProps, 'columnKey'>>(({ isHeader }) => {
  return {
    overflow: 'hidden',
    padding: spacing(0, 1),
    ...(isHeader ? { display: 'flex', alignItems: 'center' } : {}),
  };
});

export function Column({ columnKey, ...rest }: ColumnProps) {
  const isGridRow = useContext(JobsTablePresentationContext) === 'grid';
  const { sx } = jobsTableColumns[columnKey];

  return (
    <StyledColumn
      sx={[...(Array.isArray(sx) ? sx : [sx]), isGridRow && singleLineCellSx]}
      {...rest}
    />
  );
}
